// A Pro feature on Free (spec/pro.md): what it would do and the way to the Pro page. Only the server decides who has
// Pro, and it refuses Pro changes without it; this is what the page shows meanwhile.
import { navigate } from '../lib/router.ts';
import { useStore } from '../store/hooks.tsx';
import { Button } from '../ui/ds.tsx';

export function ProLock({ text, onOpen }: { text: string; onOpen?: () => void }) {
  const store = useStore();
  const t = store.t;
  return (
    <div className="pro-lock" data-testid="pro-lock">
      <span className="pro-lock__badge">PRO</span>
      <span className="pro-lock__text">{text}</span>
      <Button size="sm" onClick={() => { onOpen?.(); navigate({ name: 'pro' }); }}>{t('Pro ansehen')}</Button>
    </div>
  );
}
